"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1955],{

/***/ 10411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ submitLoginForm; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48106);
/* harmony import */ var _common_cookieOptions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62049);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var submitLoginForm = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body, setUid) {
        var response, status, _data, Code, Data;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].MEMBER */ .Z.MEMBER).post(body);
                case 2:
                    response = _ctx.sent;
                    status = response.status;
                    _data = response.data, Code = _data.Code, Data = _data.Data;
                    if (!(status === 200)) {
                        _ctx.next = 16;
                        break;
                    }
                    if (!(Code === "0000")) {
                        _ctx.next = 12;
                        break;
                    }
                    (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .setCookie */ .d8)("token", Data.token, _common_cookieOptions__WEBPACK_IMPORTED_MODULE_4__/* .authCookie */ .Z);
                    if (setUid === true) {
                        (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .setCookie */ .d8)("uid", body.uid, _common_cookieOptions__WEBPACK_IMPORTED_MODULE_4__/* .uidCookie */ .U);
                    } else {
                        (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .removeCookie */ .nJ)("uid");
                    }
                    return _ctx.abrupt("return", "Success");
                case 12:
                    if (!(Code === "9999")) {
                        _ctx.next = 14;
                        break;
                    }
                    return _ctx.abrupt("return", Data.Msg);
                case 14:
                    _ctx.next = 17;
                    break;
                case 16:
                    return _ctx.abrupt("return", console.log("\uC815\uC0C1\uC801\uC778 \uC694\uCCAD\uC774 \uC544\uB2D9\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function submitLoginForm(body, setUid) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 62049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ uidCookie; },
/* harmony export */   "Z": function() { return /* binding */ authCookie; }
/* harmony export */ });
/*
- attributes

expires: 만료 기간 (date)

maxAge: 클라이언트가 쿠키를 수신한 시점부터 쿠키의 상대적인 최대 수명 (sec)

secure: 웹 브라우저와 웹 서버가 https로 통신하는 경우에만 쿠키 저장

httpOnly: document.cookie라는 자바스크립트 코드로 쿠키에 비정상적으로 접속하는 것을 막는 옵션
*/ var authCookie = {
    sameSite: "strict",
    path: "/"
};
var uidCookie = {
    sameSite: "strict",
    path: "/",
    maxAge: 2592000
};


/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64384);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var _api_login__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10411);
/* harmony import */ var _api_members__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40542);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55150);
/* harmony import */ var _redux_action_confirm__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94184);
/* harmony import */ var _redux_action_loading__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19828);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    position: fixed;\n    top: 10%;\n    left: 35vw;\n    width: 30vw;\n    height: auto;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    @media screen and (max-width: 991px) {\n      left: 25vw;\n      width: 50vw;\n    }\n    @media screen and (max-width: 767px) {\n      left: 10vw;\n      width: 80vw;\n    }\n  }\n\n  .header {\n    display: flex;\n    padding: 10px 10px;\n    & img {\n      margin-left: auto;\n      width: 35px;\n      cursor: pointer;\n    }\n  }\n  .title {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 30px;\n    & h4 {\n      color: #3bb77e;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    & > span {\n      color: black;\n    }\n  }\n\n  .inputWrapper {\n    width: 100%;\n    margin-bottom: 20px;\n    & h6 {\n      margin-bottom: 10px;\n    }\n    & input {\n      height: 38px;\n      margin-bottom: 10px;\n      ::placeholder {\n        font-size: 14px;\n        color: #6c757da5;\n      }\n      :focus {\n        border-color: #3bb77e !important;\n        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n      }\n    }\n    .col {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      & input {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n    .row {\n      display: flex;\n      flex-direction: column;\n      .col {\n        width: 100%;\n      }\n    }\n  }\n\n  & textarea {\n    min-height: 150px;\n    ::placeholder {\n      font-size: 14px;\n      color: #6c757da5;\n    }\n    :focus {\n      border-color: #3bb77e !important;\n      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n    }\n  }\n  .btnWrapper {\n    width: 100%;\n    & button {\n      width: 100%;\n    }\n  }\n\n  .checkboxWrapper {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-column-gap: 10px;\n    margin-bottom: 20px;\n    @media screen and (max-width: 767px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  .designCheck {\n    margin-bottom: 30px;\n    display: flex;\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab71276e-0"
})(_templateObject());
var QuickSignUpModal = function(param) {
    var info = param.info, onClickQuickSignUp = param.onClickQuickSignUp, ordernum = param.ordernum, _$modifyConfirmModal = param.modifyConfirmModal, _$openConfirmModal = param.openConfirmModal, _$closeConfirmModal = param.closeConfirmModal, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), userInputs = ref4[0], setUserInputs = ref4[1];
    var onChangeUserInputs = function(e) {
        setUserInputs(_objectSpread({}, userInputs, _defineProperty({}, e.target.id, e.target.value)));
    };
    var submitSignUp = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
            var content;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        content = {
                            title: "\uAC00\uC785\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                            actionBtnLabel: "\uD655\uC778",
                            actionBtnValid: true,
                            cancelBtnLabel: "\uCDE8\uC18C",
                            onClose: function() {
                                return _$closeConfirmModal();
                            },
                            onAction: _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                                var body, res, ref, ref1, loginBody, loginRes, ref2, ref3;
                                return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _$isLoading();
                                            body = {
                                                modes: "FastJoin",
                                                uid: userInputs.uid,
                                                upass: userInputs.upass,
                                                reupass: userInputs.reupass,
                                                ordernum: ordernum ? ordernum : ""
                                            };
                                            if (!(Object.values(body).includes(null) || Object.values(body).includes(undefined))) {
                                                _ctx.next = 6;
                                                break;
                                            }
                                            (0,_common_alert__WEBPACK_IMPORTED_MODULE_7__/* .failAlert */ .qh)("\uB0B4\uC6A9\uC744 \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                                            _$isLoaded();
                                            return _ctx.abrupt("return");
                                        case 6:
                                            _ctx.next = 8;
                                            return (0,_api_members__WEBPACK_IMPORTED_MODULE_6__/* .postMember */ ._)(body);
                                        case 8:
                                            res = _ctx.sent;
                                            if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                                                _ctx.next = 21;
                                                break;
                                            }
                                            ;
                                            _$closeConfirmModal();
                                            globalThis.dataLayer.push({
                                                event: "3second_Sign_up"
                                            });
                                            (0,_common_alert__WEBPACK_IMPORTED_MODULE_7__/* .successAlert */ .Cq)((res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) ? res === null || res === void 0 ? void 0 : (ref1 = res.Data) === null || ref1 === void 0 ? void 0 : ref1.Msg : "\uAC00\uC785\uB418\uC5C8\uC2B5\uB2C8\uB2E4!");
                                            loginBody = {
                                                modes: "Login",
                                                uid: userInputs.uid,
                                                upass: userInputs.upass
                                            };
                                            _ctx.next = 17;
                                            return (0,_api_login__WEBPACK_IMPORTED_MODULE_5__/* .submitLoginForm */ .X)(loginBody, false);
                                        case 17:
                                            loginRes = _ctx.sent;
                                            if (loginRes === "Success") {
                                                onClickQuickSignUp();
                                                router.reload();
                                                _$isLoaded();
                                            }
                                            _ctx.next = 22;
                                            break;
                                        case 21:
                                            {
                                                ;
                                                (0,_common_alert__WEBPACK_IMPORTED_MODULE_7__/* .failAlert */ .qh)((res === null || res === void 0 ? void 0 : (ref2 = res.Data) === null || ref2 === void 0 ? void 0 : ref2.Msg) ? res === null || res === void 0 ? void 0 : (ref3 = res.Data) === null || ref3 === void 0 ? void 0 : ref3.Msg : "\uD68C\uC6D0\uAC00\uC785 \uC2E4\uD328");
                                                _$closeConfirmModal();
                                                _$isLoaded();
                                            }
                                        case 22:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        };
                        _$modifyConfirmModal(content);
                        _$openConfirmModal();
                    case 3:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function submitSignUp() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: "/assets/imgs/page/common/modal_close_icon.png",
                            alt: "modal_close_icon",
                            onClick: onClickQuickSignUp
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                            children: "\uC8FC\uBB38\uC815\uBCF4\uB85C \uD68C\uC6D0 \uAC00\uC785"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "inputWrapper",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                        children: "\uC544\uC774\uB514"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                        type: "text",
                                                        id: "uid",
                                                        onChange: onChangeUserInputs
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                        children: "\uBE44\uBC00\uBC88\uD638"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                        type: "password",
                                                        autoComplete: "new-password",
                                                        id: "upass",
                                                        onChange: onChangeUserInputs
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                    children: "\uBE44\uBC00\uBC88\uD638 \uD655\uC778"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                    type: "password",
                                                    autoComplete: "new-password",
                                                    id: "reupass",
                                                    onChange: onChangeUserInputs
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "btnWrapper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    className: "btn",
                                    onClick: submitSignUp,
                                    children: "\uAC00\uC785\uD558\uAE30"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var mapDispatchToProps = {
    openConfirmModal: _redux_action_confirm__WEBPACK_IMPORTED_MODULE_9__/* .openConfirmModal */ ._5,
    modifyConfirmModal: _redux_action_confirm__WEBPACK_IMPORTED_MODULE_9__/* .modifyConfirmModal */ .sR,
    closeConfirmModal: _redux_action_confirm__WEBPACK_IMPORTED_MODULE_9__/* .closeConfirmModal */ .d6,
    isLoaded: _redux_action_loading__WEBPACK_IMPORTED_MODULE_10__/* .isLoaded */ .k,
    isLoading: _redux_action_loading__WEBPACK_IMPORTED_MODULE_10__/* .isLoading */ .h
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .connect */ .$j)(null, mapDispatchToProps)(QuickSignUpModal));


/***/ })

}]);